import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiChevronLeft, FiChevronRight, FiStar, FiMapPin, FiCalendar, FiUsers, FiInfo } = FiIcons;

const References = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const references = [
    {
      company: 'Swiss Banking AG',
      logo: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80',
      image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      location: 'Zürich',
      size: '15.000 m²',
      services: ['Reinigungsmanagement', 'Technisches FM', 'Sicherheitsdienste'],
      description: 'Komplette Facility Management Betreuung der Hauptverwaltung mit 500 Arbeitsplätzen.',
      duration: 'Seit 2018',
      challenge: 'Hohe Sicherheitsanforderungen im Bankenwesen',
      solution: 'Speziell geschultes Personal und zertifizierte Sicherheitsprozesse',
      results: ['99.8% Verfügbarkeit', '25% Kosteneinsparung', '100% Compliance']
    },
    {
      company: 'TechCorp International',
      logo: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80',
      image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      location: 'Basel',
      size: '8.500 m²',
      services: ['Büroreinigung', 'IT-Support', 'Empfangsdienste'],
      description: 'Moderne Büroräume mit flexiblen Arbeitsplätzen und hochtechnischer Ausstattung.',
      duration: 'Seit 2020',
      challenge: 'Flexible Arbeitszeiten und hybride Arbeitsmodelle',
      solution: 'Anpassbare Reinigungszeiten und digitale Buchungssysteme',
      results: ['95% Mitarbeiterzufriedenheit', '30% Effizienzsteigerung', 'CO₂-Reduktion um 20%']
    },
    {
      company: 'Medizinzentrum Alpenblick',
      logo: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80',
      image: 'https://images.unsplash.com/photo-1551601651-2a8555f1a136?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      location: 'Bern',
      size: '12.000 m²',
      services: ['Spezialreinigung', 'Desinfektion', 'Abfallmanagement'],
      description: 'Krankenhaus mit 200 Betten und modernsten medizinischen Einrichtungen.',
      duration: 'Seit 2019',
      challenge: 'Höchste Hygieneanforderungen im Gesundheitswesen',
      solution: 'Zertifizierte Krankenhaus-Hygiene und spezialisierte Teams',
      results: ['Null Hygiene-Verstöße', '99.9% Keimfreiheit', 'Zertifizierung erneuert']
    },
    {
      company: 'Shopping Center Paradeplatz',
      logo: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80',
      image: 'https://images.unsplash.com/photo-1555529669-e69e7aa0ba9a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      location: 'Zürich',
      size: '25.000 m²',
      services: ['Reinigungsmanagement', 'Sicherheitsdienste', 'Winterdienst'],
      description: 'Großes Einkaufszentrum mit 80 Geschäften und 2000 Parkplätzen.',
      duration: 'Seit 2017',
      challenge: 'Hohe Besucherfrequenz und 7-Tage-Betrieb',
      solution: '24/7 Service-Teams und intelligente Reinigungsplanung',
      results: ['98% Kundenzufriedenheit', 'Keine Ausfallzeiten', '15% Kostensenkung']
    }
  ];

  const testimonials = [
    {
      name: 'Dr. Michael Brunner',
      position: 'Facility Manager',
      company: 'Swiss Banking AG',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
      text: 'Hubler & Tex überzeugt durch Zuverlässigkeit und Professionalität. Die Zusammenarbeit ist seit Jahren reibungslos und die Qualität konstant hoch.',
      rating: 5
    },
    {
      name: 'Sarah Weber',
      position: 'Operations Director',
      company: 'TechCorp International',
      image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
      text: 'Die flexible Anpassung an unsere Arbeitsmodelle und die digitalen Lösungen haben uns überzeugt. Ein Partner, der mitdenkt und Lösungen entwickelt.',
      rating: 5
    },
    {
      name: 'Prof. Dr. Andreas Keller',
      position: 'Ärztlicher Direktor',
      company: 'Medizinzentrum Alpenblick',
      image: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
      text: 'Die Expertise im Bereich Krankenhaus-Hygiene ist außergewöhnlich. Wir können uns vollständig auf die medizinische Versorgung konzentrieren.',
      rating: 5
    }
  ];

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <div>
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-r from-orange-500 to-orange-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center text-white"
          >
            <h1 className="text-5xl font-bold mb-6">
              Unsere Referenzen
            </h1>
            <p className="text-xl max-w-3xl mx-auto">
              Vertrauen Sie auf unsere Erfahrung. Diese Kunden setzen bereits erfolgreich auf unsere Facility Management Lösungen.
            </p>
          </motion.div>
        </div>
      </section>

      {/* References Grid */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          {/* Staging Notice Box */}
          <div className="max-w-4xl mx-auto mb-16 bg-slate-50 border border-slate-200 rounded-xl p-4 sm:p-6 flex items-start shadow-sm">
            <SafeIcon icon={FiInfo} className="w-6 h-6 text-slate-500 mr-4 flex-shrink-0 mt-0.5" />
            <p className="text-slate-700 text-sm sm:text-base">
                <strong className="font-semibold text-slate-900">ℹ️ Vorschau-Modus:</strong> Die abgebildeten Referenzen dienen der Layout-Visualisierung. Echte Kundendaten werden nach Live-Schaltung der Datenbank importiert.
            </p>
          </div>

          <div className="space-y-16">
            {references.map((reference, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
                className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${index % 2 === 1 ? 'lg:grid-flow-col-dense' : ''}`}
              >
                <div className={index % 2 === 1 ? 'lg:col-start-2' : ''}>
                  <div className="flex items-center mb-6">
                    <img src={reference.logo} alt={`${reference.company} Logo`} className="w-16 h-16 rounded-lg object-cover mr-4" />
                    <div>
                      <h3 className="text-2xl font-bold text-gray-900">
                        {reference.company}
                      </h3>
                      <div className="flex items-center text-gray-600 space-x-4">
                        <div className="flex items-center">
                          <SafeIcon icon={FiMapPin} className="w-4 h-4 mr-1" />
                          {reference.location}
                        </div>
                        <div className="flex items-center">
                          <SafeIcon icon={FiUsers} className="w-4 h-4 mr-1" />
                          {reference.size}
                        </div>
                        <div className="flex items-center">
                          <SafeIcon icon={FiCalendar} className="w-4 h-4 mr-1" />
                          {reference.duration}
                        </div>
                      </div>
                    </div>
                  </div>

                  <p className="text-lg text-gray-600 mb-6">
                    {reference.description}
                  </p>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-2">Leistungen:</h4>
                      <ul className="space-y-1">
                        {reference.services.map((service, serviceIndex) => (
                          <li key={serviceIndex} className="text-gray-600 text-sm">
                            • {service}
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-2">Ergebnisse:</h4>
                      <ul className="space-y-1">
                        {reference.results.map((result, resultIndex) => (
                          <li key={resultIndex} className="text-gray-600 text-sm">
                            • {result}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>

                  <div className="bg-gray-50 rounded-lg p-6">
                    <h4 className="font-semibold text-gray-900 mb-2">Herausforderung:</h4>
                    <p className="text-gray-600 text-sm mb-4">{reference.challenge}</p>
                    <h4 className="font-semibold text-gray-900 mb-2">Lösung:</h4>
                    <p className="text-gray-600 text-sm">{reference.solution}</p>
                  </div>
                </div>
                <div className={index % 2 === 1 ? 'lg:col-start-1 lg:row-start-1' : ''}>
                  <img src={reference.image} alt={reference.company} className="rounded-lg shadow-lg w-full h-96 object-cover" />
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Carousel */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Was unsere Kunden sagen
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Echte Bewertungen von echten Kunden
            </p>
          </motion.div>

          <div className="relative max-w-4xl mx-auto">
            <motion.div
              key={currentTestimonial}
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -50 }}
              transition={{ duration: 0.5 }}
              className="bg-white rounded-xl shadow-lg p-8 md:p-12"
            >
              <div className="flex items-center mb-6">
                {[...Array(testimonials[currentTestimonial].rating)].map((_, i) => (
                  <SafeIcon key={i} icon={FiStar} className="w-5 h-5 text-yellow-400 fill-current" />
                ))}
              </div>
              <blockquote className="text-xl text-gray-700 mb-8 italic">
                "{testimonials[currentTestimonial].text}"
              </blockquote>
              <div className="flex items-center">
                <img
                  src={testimonials[currentTestimonial].image}
                  alt={testimonials[currentTestimonial].name}
                  className="w-16 h-16 rounded-full object-cover mr-4"
                />
                <div>
                  <div className="font-semibold text-gray-900">
                    {testimonials[currentTestimonial].name}
                  </div>
                  <div className="text-gray-600">
                    {testimonials[currentTestimonial].position}
                  </div>
                  <div className="text-orange-500 font-semibold">
                    {testimonials[currentTestimonial].company}
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Navigation */}
            <button
              onClick={prevTestimonial}
              className="absolute left-0 top-1/2 transform -translate-y-1/2 -translate-x-4 bg-white rounded-full p-3 shadow-lg hover:bg-gray-50 transition-colors"
            >
              <SafeIcon icon={FiChevronLeft} className="w-6 h-6 text-gray-600" />
            </button>
            <button
              onClick={nextTestimonial}
              className="absolute right-0 top-1/2 transform -translate-y-1/2 translate-x-4 bg-white rounded-full p-3 shadow-lg hover:bg-gray-50 transition-colors"
            >
              <SafeIcon icon={FiChevronRight} className="w-6 h-6 text-gray-600" />
            </button>

            {/* Dots */}
            <div className="flex justify-center mt-8 space-x-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentTestimonial(index)}
                  className={`w-3 h-3 rounded-full transition-colors ${index === currentTestimonial ? 'bg-orange-500' : 'bg-gray-300'}`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-20 bg-orange-500">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-white mb-16">
            <h2 className="text-4xl font-bold mb-6">
              Zahlen, die sprechen
            </h2>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center text-white">
            <div>
              <div className="text-4xl font-bold mb-2">500+</div>
              <div className="text-orange-100">Zufriedene Kunden</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">2.5M</div>
              <div className="text-orange-100">m² betreute Fläche</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">99.8%</div>
              <div className="text-orange-100">Verfügbarkeit</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">15+</div>
              <div className="text-orange-100">Jahre Erfahrung</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default References;